module.exports = __webpack_public_path__ + "static/media/indentpopupimage.2db7859d.png";